import { Injectable, isDevMode } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoggerService {
  private readonly enabled = isDevMode();

  log(...args: any[]): void {
    this.enabled && console.log(...args);
  }

  warn(...args: any[]): void {
    this.enabled && console.warn(...args);
  }

  error(...args: any[]): void {
    this.enabled && console.error(...args);
  }
}
